import * as ActionTypes from "constants/ActionTypes";

// `AD_COMPLETED`

export const setInactivity = (key, value) => ({
  key,
  type: ActionTypes.SET_INACTIVITY,
  value,
});

export const reportActivity = () => ({
  type: ActionTypes.REPORT_ACTIVITY,
});

export const reportUIActivity = () => (dispatch, getState) => {
  const state = getState();

  // If volume is initially muted and we haven't yet unmuted, then unmute
  //
  // Also, flag that we've unmuted so we don't try to unmute if the user
  // manually mutes later
  if (
    state.volume.wasInitiallyMuted &&
    !state.volume.unmutedVolumeFromUIActivity &&
    state.playerOptions.autoplay === 2
  ) {
    dispatch({
      type: ActionTypes.SET_VOLUME_MUTED,
      value: false,
    });

    dispatch({
      type: ActionTypes.UNMUTE_VOLUME_FROM_UI_ACTIVITY,
    });
  }

  dispatch({
    type: ActionTypes.REPORT_UI_ACTIVITY,
  });
};

export const forceInactivity = () => ({
  type: ActionTypes.FORCE_INACTIVITY,
});

export const setTransitioning = (value) => ({
  type: ActionTypes.SET_TRANSITIONING,
  value,
});
